module.exports = {
      id: "icon-audio-instagram-usage",
      viewBox: "0 0 25.21 25.21",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-audio-instagram",
      toString: function () {
        return this.url;
      }
    }